import { render, staticRenderFns } from "./SettingsLabels.vue?vue&type=template&id=7dcbb93a&"
import script from "./SettingsLabels.vue?vue&type=script&lang=js&"
export * from "./SettingsLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports